"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _constant = require("../../styles/constant");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
const wrapperBorder = (0, _styledSystem.variant)({
  variants: {
    "default": {
      border: '1px solid',
      borderColor: (0, _constant.get)('colors.functional.grey.400')
    },
    vanity: {
      borderBottom: '1px solid',
      borderColor: (0, _constant.get)('colors.functional.grey.400')
    }
  }
});
const headerSize = (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.14'),
      lineHeight: (0, _constant.get)('lineHeights.20'),
      padding: props => "".concat((0, _constant.get)('space.5')(props), " ").concat((0, _constant.get)('space.11')(props))
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.16'),
      lineHeight: (0, _constant.get)('lineHeights.24'),
      padding: props => "".concat((0, _constant.get)('space.7')(props), " ").concat((0, _constant.get)('space.15')(props))
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.18'),
      lineHeight: (0, _constant.get)('lineHeights.28'),
      padding: props => "".concat((0, _constant.get)('space.11')(props), " ").concat((0, _constant.get)('space.23')(props))
    }
  }
});
const bodySize = (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.14'),
      padding: props => "".concat((0, _constant.get)('space.6')(props), " ").concat((0, _constant.get)('space.12')(props))
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.16'),
      padding: props => "".concat((0, _constant.get)('space.8')(props), " ").concat((0, _constant.get)('space.16')(props))
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.18'),
      padding: props => "".concat((0, _constant.get)('space.12')(props), " ").concat((0, _constant.get)('space.24')(props))
    }
  }
});
const variants = {
  bodySize,
  headerSize,
  wrapperBorder
};
const Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  display: flex;\n  flex-direction: column;\n  border-radius: ", ";\n"])), variants.wrapperBorder, (0, _constant.get)('space.4'));
const Header = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", "\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: ", ";\n  cursor: pointer;\n  color: ", ";\n  background-color: transparent;\n  border: 0;\n  &:hover {\n    background-color: ", ";\n  }\n\n  @media screen and (", ") {\n    margin-left: ", ";\n  }\n  &__left-block {\n    display: flex;\n    align-items: center;\n    @media screen and (", ") {\n      flex-direction: column;\n    }\n  }\n"])), variants.headerSize, (0, _constant.get)('space.4'), (0, _constant.get)('colors.functional.grey.900'), (0, _constant.get)('colors.functional.grey.100'), (0, _constant.get)('sizes.medium'), (0, _constant.get)('space.40'), (0, _constant.get)('sizes.medium'));
const HeaderLeftBlock = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])([""])));
const HeaderContent = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  border-radius: ", ";\n"])), (0, _constant.get)('colors.functional.grey.900'), (0, _constant.get)('space.4'));
const HeaderRightBlock = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));
const Body = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  line-height: ", ";\n  text-rendering: optimizeLegibility;\n  ", "\n  color: ", ";\n\n  &[aria-expanded='true'] {\n    transition: cubic-bezier(0.215, 0.61, 0.355, 1);\n    display: block;\n    transition: all 0.25s ease 0s;\n  }\n\n  > p {\n    line-height: ", ";\n    margin: 0;\n  }\n"])), (0, _constant.get)('lineHeights.24'), variants.bodySize, (0, _constant.get)('colors.functional.grey.800'), (0, _constant.get)('lineHeights.24'));
const Components = exports.Components = {
  Wrapper,
  Header,
  HeaderLeftBlock,
  HeaderContent,
  HeaderRightBlock,
  Body
};